import React, { Component } from 'react'
import Radium from 'radium'

const styles = {
    button: {
        backgroundColor: 'inherit',
        float: 'left',
        border: 'none',
        outline: 'none',
        cursor: 'pointer',
        padding: 10,
        transition: '0.3s',
        ':hover': {
            backgroundColor: '#ddd',
        },
    },
    active: {
        backgroundColor: '#ccc'
    }
}

function TabButton({ onClick, text, active }) {
    let activeStyle = {}
    if (active) { activeStyle = styles.active }
    return (
        <button
            style={[styles.button, activeStyle]}
            onClick={onClick}
        >
            {text}
        </button >
    )
}

export default Radium(TabButton)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Invoice/tabbar/tabbutton.js